const API_URL = import.meta.env.FRONT_API_URL;

export async function getMe() {
	const res = await fetch(`${API_URL}auth/me`, { credentials: 'include' });
	if (!res.ok) {
		throw new Error('Failed to fetch user');
	}
	return res.json();
}

export async function signIn(email, password, recaptchaToken) {
	const res = await fetch(`${API_URL}auth/local`, {
		method: 'POST',
		credentials: 'include',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ username: email, password, recaptchaToken })
	});
	if (!res.ok) {
		const err = await res.json().catch(() => ({}));
		throw new Error(err.code || 'login-failed');
	}
	return res.json();
}

export async function signOut() {
	await fetch(`${API_URL}auth/logout`, {
		method: 'POST',
		credentials: 'include'
	});
}

export async function connectAs(id) {
	const res = await fetch(`${API_URL}auth/as`, {
		method: 'POST',
		credentials: 'include',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ id })
	});
	if (!res.ok) {
		throw new Error('connect-as-failed');
	}
	return res.json();
}
